import { createActionCreator } from '../../utils/helpers';

import {
  OPEN_FUNDING_SEARCH_PRIVACY_TOGGLE_MODAL,
  CLOSE_FUNDING_SEARCH_PRIVACY_TOGGLE_MODAL,
  fundingSearchPrivacyToggle,
} from './types';

export const openFundingSearchPrivacyToggleModal = createActionCreator(
  OPEN_FUNDING_SEARCH_PRIVACY_TOGGLE_MODAL,
  'fundingSearch',
);
export const closeFundingSearchPrivacyToggleModal = createActionCreator(
  CLOSE_FUNDING_SEARCH_PRIVACY_TOGGLE_MODAL,
  'fundingSearch',
);

export const requestFundingSearchPrivacyToggle = createActionCreator(
  fundingSearchPrivacyToggle.request,
  'fundingSearchId',
  'promise',
);
export const requestFundingSearchPrivacyToggleSuccess = createActionCreator(
  fundingSearchPrivacyToggle.success,
  'fundingSearchId',
  'response',
);
